export const kombuchaBottles = [
  {
    title: "LA NIÑA\nBONITA",
    price: '3.00',
    ingredients: [
      { iconType: 'color', icon: '#FACC15', name: 'Fermented Tea', amount: '300 ml' },
      { iconType: 'color', icon: '#29095D', name: 'BlackBerry Juice', amount: '150 ml' },
      { iconType: 'color', icon: '#BE185D', name: 'Strawberry Juice', amount: '350 ml' },
      { iconType: 'img', icon: '/images/Hobbies/rhubarb.webp', name: 'Sweet Rhubarb Chunks', amount: '30 ml' },
    ],
    personality: `She's 'The Pretty Girl' and she knows it. Sweet, sassy, and uninterested in your texts.`,
    liquidColor: '#BE185D', 
    priceColor: '#A21CAF', 
  },
  {
    title: "D'MANGO\nUNCHAINED",
    price: '3.00',
    ingredients: [
      { iconType: 'color', icon: '#FACC15', name: 'Fermented Tea', amount: '300 ml' },
      { iconType: 'color', icon: '#FBBF24', name: 'Mango Juice', amount: '250 ml' },
      { iconType: 'color', icon: '#FDE68A', name: 'Pinapple Juice', amount: '250 ml' },
      { iconType: 'img', icon: '/images/Hobbies/ginger.svg', name: 'Ginger', amount: '50 ml' },
    ],
    personality: `This isn't a drink, it's a screenplay in a bottle. Bold leads, no filler, and a twist courtesy of ginger.`,
    liquidColor: '#FBBF24', 
    priceColor: '#F59E42', 
  },
  {
    title: "SORREL\nSUNSENT",
    price: '2.50',
    ingredients: [
      { iconType: 'color', icon: '#FACC15', name: 'Fermented Tea', amount: '300 ml' },
      { iconType: 'color', icon: '#991B1B', name: 'Sorrel/Jamaica', amount: '450 ml' },
      { iconType: 'img', icon: '/images/Hobbies/ginger.svg', name: 'Ginger', amount: '50 ml' },
    ],
    personality: `Lures you in with its vibrant red glow, then bites back with ginger-shaped teeth.`,
    liquidColor: '#991B1B', 
    priceColor: '#F87171', 
  },
];

export default kombuchaBottles; 